import { Loading } from 'element-ui';
let loadingCount = 0;
let loading;
const startLoading = (type, text) => {
    loading = Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        customClass: type && type == 1 ? 'vertical-loading' : '',
        text: text ? text : '正在加载',
        background: 'rgba(0, 0, 0, 0.5)',
    });
};

const endLoading = () => {
    loading.close();
};

export const showLoading = (type, text, callback) => {
    if (loadingCount === 0) {
        startLoading(type, text);
        if(callback) {
          callback()
        }
    }
    loadingCount += 1;
};

export const hideLoading = () => {
    if (loadingCount <= 0) {
        return;
    }
    loadingCount -= 1;
    if (loadingCount === 0) {
        endLoading();
    }
};
